import { type RefObject, useEffect } from 'react';

type Props = {
  initFocus?: boolean;
  minHeight?: number;
  value?: string;
};

const useFlexibleTextarea = (
  props: Props,
  ref: RefObject<HTMLTextAreaElement>,
) => {
  useEffect(() => {
    const target = ref.current;
    if (target) {
      if (props.initFocus) target.focus();

      // 높이를 일시적으로 초기화하여 실제 필요한 높이를 정확히 측정
      target.style.height = 'auto';

      // 최소 높이와 실제 스크롤 높이 중 큰 값으로 설정
      const minHeight = props.minHeight || 0;
      const scrollHeight = target.scrollHeight;
      const finalHeight = Math.max(minHeight, scrollHeight);

      target.style.height = `${finalHeight}px`;
    }
  }, [props.initFocus, props.minHeight, props.value, ref]);
};

export default useFlexibleTextarea;
